import { i, s, x } from '../../lit-element.js';
import { v as validateAllFields, q as querySelectorDeep } from '../../validate-all-fields.js';
import { buttons } from '../../styles/buttons.style.js';

const style = i`
  :host {
    display: block;
    font-size: 16px;
  }

  :host([hidden]) {
    display: none;
  }

  .questions-container {
    margin: 0 1em 1.5em;
  }

  @media (min-width: 48em) {
    .questions-container {
      margin: 0 auto 1.5em;
      max-width: 30em;
    }
  }

  .grv-button {
    display: block;
    margin: 0 auto;
  }
`;

class RefiVerifyIdQuiz extends s {
  constructor() {
    super();
    this.answers = {};
    this.quiz = {
      questions: [],
    };
  }

  static get properties() {
    return {
      quiz: { type: Object, attribute: true },
    };
  }

  static get styles() {
    return [buttons, style];
  }

  render() {
    return x`
      <form name="verifyIdQuiz" @submit="${this.validateQuiz}" novalidate autocomplete="off">
        <refi-common-page-header>
          <h2>We need to verify some information before moving forward.</h2>
        </refi-common-page-header>
        <div class="questions-container">
          ${this.quiz.questions.map(question => x` <refi-verify-id-quiz-question id="question${question.questionId}" .question="${question}"></refi-verify-id-quiz-question> `)}
        </div>
        <button class="grv-button">Verify Me</button>
      </form>
    `;
  }

  validateQuiz(ev) {
    ev.preventDefault();
    const form = ev.target;
    const isValid = validateAllFields(form);
    if (isValid) {
      this.answers = {
        sessionId: this.quiz.sessionId,
        custAns: [],
      };
      this.quiz.questions.forEach(question => {
        const { questionId } = question;
        const choiceNumber = querySelectorDeep(`input[name="question${questionId}"]:checked`).value;
        this.answers.custAns.push({ questionId, choiceNumber });
      });
      this.dispatchEvent(
        new CustomEvent('validated-quiz', {
          bubbles: true,
          detail: this.answers,
        }),
      );
    }
  }
}

export { RefiVerifyIdQuiz };
